import React from 'react'
import { cn } from '../../Utils/component'
import { LinkButton } from '../common/menu/linkButton'
import type { ButtonProps } from './button/types'
import { getButtonColor, getButtonSize } from './button/utils'

const Button = ({
  color,
  invert = false,
  label,
  submit = false,
  size = undefined,
  filter = false,
  onClick = undefined,
  disabled = false,
  href,
  isExternal = false,
  children,
}: ButtonProps) => {
  if (href) {
    return (
      <LinkButton
        label={label as string}
        href={href}
        isInverted={invert}
        isExternal={isExternal}
        size={size}
      />
    )
  }

  const classes = cn([
    'disabled:opacity-80 disabled:cursor-not-allowed transition-colors font-semibold rounded-md',
    getButtonColor(color, invert),
    getButtonSize(size),
    filter ? 'border' : 'border-2',
    disabled ? 'cursor-not-allowed' : 'cursor-pointer',
  ])

  return (
    <button
      className={classes}
      type={submit ? 'submit' : 'button'}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled}
    >
      {label || children}
    </button>
  )
}

export default Button
